import { cloneDeep } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AutoComplete from 'material-ui/AutoComplete';

import { updateCargoOrder } from 'actions/cargoes/orders';

class Type extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cargoTypes: props.cargoTypes,
        };

        this.selectDetails = this.selectDetails.bind(this);
        this.onChangeAutoComplete = this.onChangeAutoComplete.bind(this);
        this.onChooseAutoComplete = this.onChooseAutoComplete.bind(this);
    }

    selectDetails(value) {
        const newCargoOrder = cloneDeep(this.props.cargoOrder);
        newCargoOrder.details = +value;
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    onChangeAutoComplete(searchText) {
        let { cargoTypes } = this.props;

        cargoTypes = cargoTypes.filter((cargoName) => {
            if (cargoName.name.toLowerCase().includes(searchText.toLowerCase())) {
                return {
                    name: cargoName.name,
                    item: cargoName,
                };
            }
            return false;
        });

        this.setState({
            cargoTypes,
        });

        const newCargoOrder = cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargoTypeName = searchText;
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    onChooseAutoComplete(updateProperties) {
        if (!updateProperties) {
            return;
        }

        const newCargoOrder = cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargoType = updateProperties.item._id;
        newCargoOrder.cargoTypeName = updateProperties.name;
        newCargoOrder.details = updateProperties.item.details;
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);

        this.setState({
            searchTextCargoType: updateProperties.name,
        });
    }

    render() {
        const errorType = this.props.errorType ? this.props.errorType.messages[0] : '';

        return (
            <div>
                <div className='row'>
                    <div className='column-left'>
                         Type:
                    </div>
                    <div className='column-right'>
                        <div className='label'>
                            Cargo type id - {this.props.cargoOrder.cargoType ? this.props.cargoOrder.cargoType : 'empty'}
                        </div>
                        <div className='label'>
                            Details - {this.props.cargoOrder.details}
                        </div>
                        <AutoComplete
                            textFieldStyle={{ fontSize: '13px' }}
                            hintText='Cargo type'
                            searchText={this.props.cargoOrder.cargoTypeName || ''}
                            dataSource={this.state.cargoTypes}
                            dataSourceConfig={{ text: 'name', value: 'item' }}
                            onUpdateInput={this.onChangeAutoComplete}
                            onNewRequest={this.onChooseAutoComplete}
                            errorText={errorType}
                            filter={AutoComplete.noFilter}
                            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                            popoverProps={{
                                canAutoPosition: true,
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const cargoTypes = state.cargoTypes.map(cargoType => ({
            name: cargoType.name,
            item: cargoType,
        }));

        cargoTypes.push({
            name: 'Other',
            item: {
                _id: '59970a4513d689b67b8bf20d',
            },
        });

        const errorType = state.cargoOrders.items[ownProps.numberOrderTable].validateErrors
            .find(validateError => validateError.field === 'cargo.0.cargoType');

        return {
            numberOrderTable: ownProps.numberOrderTable,
            cargoTypes,
            errorType,
            cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable],
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(Type);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Type.jsx